"use client";

import * as React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const faqs = [{
  question: "How fast can you reach me in Leeds?",
  answer: "We pride ourselves on our rapid response. Typically, our mobile tyre fitting experts arrive at your location in Leeds, Headingley, or surrounding areas within 30 to 60 minutes of your call."
}, {
  question: "Are you available for emergency callouts 24/7?",
  answer: "Yes, we operate 24 hours a day, 7 days a week. Whether it's a midnight puncture on the M621 or a Sunday morning flat in Roundhay, our emergency tyre fitting team is always on standby."
}, {
  question: "Do you offer mobile puncture repair?",
  answer: "Absolutely. If your tyre can be safely repaired according to BSAU 159 standards, we will perform a mobile puncture repair on-site to save you the cost of a new tyre."
}, {
  question: "What payment methods do you accept?",
  answer: "For your convenience, we accept all major credit and debit cards, contactless payments, and cash. Our mobile units are equipped with secure card terminals for on-the-spot transactions."
}, {
  question: "Do I need to provide any tools or equipment?",
  answer: "Not at all. Our specialized mobile tyre fitting vans are fully equipped with state-of-the-art machinery, including wheel balancers and compressors, to handle the entire job at your roadside or home."
}];
export default function CommonInquiries() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223896" id="common-tyre-questions" className="bg-background text-foreground py-20 px-6 md:px-12 lg:px-24 overflow-hidden">
      <div ref={ref} className={`max-w-3xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-default font-bold tracking-tighter uppercase mb-4">
            Common Tyre Questions
          </h2>
          <p className="text-muted-foreground font-serif text-lg max-w-2xl mx-auto">
            Everything you need to know about our 24/7 mobile tyre fitting and emergency roadside assistance in Leeds.
          </p>
        </div>

        <div className="border border-border/40 rounded-xl p-4 md:p-8 bg-card/50 backdrop-blur-md shadow-xl">
          <Accordion type="single" collapsible className="w-full">
            {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-index={i} className="border-border/40">
                <AccordionTrigger className="text-left font-default font-bold text-base md:text-lg hover:no-underline hover:text-primary transition-colors py-5">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-muted-foreground font-serif text-base leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>)}
          </Accordion>
        </div>
      </div>
    </section>;
}